import { Entity } from '..'

export class Details extends Entity {
  metadata: Record<string, any>
  value: string
  idStock: number
}
